export default __webpack_public_path__ + "static/media/887.af810e6d.png";